import React, { useContext } from 'react'
import styles from './Media.module.css'
import { ScoreCardContext } from '../../store/scorecard-context'

const SectionsScore = (props: any) => {

    const scorecardCtx = useContext(ScoreCardContext)

    const triggerSection = (idx: number) => {
        scorecardCtx.updateActiveSection(idx)
        props.setIsCEAActive(false)
    }

    const sections = scorecardCtx?.scores?.sections?.length > 0 && scorecardCtx?.scores?.sections.map((section: any, idx: number) => {
        let score: any = (section.review_score || section.review_score == 0) ? `${section.review_score}/${section?.questions.length}`: '-' 
        
        // Critical Issues: if 1 or more questions are Yes then show “X of 4”; for 0 display “None” 
        if(section.name.toLowerCase() == 'critical issues') {
            let totalQuestions = section?.questions.length
            let yesAnswers = 0
            section?.questions && section?.questions.length > 0 && section?.questions.map((question: any) => {
                question?.options && question?.options.length > 0 && question?.options.map((option: any) => {
                    if(option.name.toLowerCase() == 'yes') {
                        if(option.is_answer) {
                            yesAnswers += 1
                        }
                    }
                })
            })
            score = yesAnswers ? `${yesAnswers} of ${totalQuestions}` : <span style={{fontSize: '18px'}}>None</span>
        }

        return  <li key={`${section}-${idx}`}>
                    <div className={scorecardCtx.activeSection == idx && !props.isCEAActive ? styles.active : ''} onClick={() => triggerSection(idx)}>
                        <p>{score}</p>
                        <h6>{section.name}</h6>
                    </div>
                </li>
    })

    return (
        (scorecardCtx?.scores?.ai_analysed || scorecardCtx?.scores?.review_by != 'AI')?
            <div className={`col-sm-10 ${styles.scetionsScoreContainer}`}>
                <ul className={`${styles.sectionsScoreBlock} d-flex align-items-center justify-content-between`}>
                    {sections}
                </ul>
            </div> :
            null
    )
}

export default SectionsScore